import axiosAuthInstance from "../utils/getSubdomain"
import { hasLearnerSession } from "../auth/learner/session"
import { axiosStudentInstance } from "./studentAuth"

const UPLOAD_IMAGE_PATH = "/upload-image/"

export const uploadImage = (formData: FormData) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }

  // TipTap is shared; learners store token under student_* keys and use
  // /api/student client. Absolute URL keeps the shared /api/upload-image/
  // endpoint while still attaching the learner token + refresh handling.
  if (hasLearnerSession()) {
    return axiosStudentInstance.post(
      `${process.env.REACT_APP_BASE_URL}/api${UPLOAD_IMAGE_PATH}`,
      formData,
      config
    )
  }

  return axiosAuthInstance.post(UPLOAD_IMAGE_PATH, formData, config)
}
